exports.components = {
  "component---node-modules-gatsby-theme-mate-src-templates-not-found-tsx": () => import("./../../../node_modules/gatsby-theme-mate/src/templates/NotFound.tsx" /* webpackChunkName: "component---node-modules-gatsby-theme-mate-src-templates-not-found-tsx" */),
  "component---src-gatsby-theme-mate-templates-home-tsx": () => import("./../../../src/gatsby-theme-mate/templates/Home.tsx" /* webpackChunkName: "component---src-gatsby-theme-mate-templates-home-tsx" */)
}

